namespace $ { $mol_style_attach( "mpds/visavis/plot/cube/cube.view.css",
 "[mpds_visavis_plot_cube_plot] g.hovertext text {\n\tcursor: pointer;\n}\n"
) }